export default __webpack_public_path__ + "static/media/food-apple-outline.67ca5811.svg";